export { default as H1 } from "./H1";
export { default as H2 } from "./H2";
export { default as H3 } from "./H3";
export { default as H4 } from "./H4";
export { default as H5 } from "./H5";
export { default as P } from "./P";
export { default as Label } from "./Label";
export { default as BlockQuote } from "./BlockQuote";
export { default as Note } from "./Note";
export { default as TickBlock } from "./TickBlock";
